angular.module('dpw.services').factory('preLoader', function () {
    var preloader = $('#preloader');

    function showLoadingLayer(sync) {
        // For DOM operations blocking the page, make it 'active' first.
        sync && preloader.addClass('active');
        preloader.show();
        preloader.find('.preloader-loading-loader').attr('id', 'x-loader');
        setTimeout(function () {
            preloader.addClass('active');
        }, 1);
        RCDPW.loadingCount++;
    }

    function hideLoadingLayer() {
        if (!(--RCDPW.loadingCount)) {
            preloader.hide();
            preloader.removeClass('active');
            preloader.find('.preloader-loading-loader').attr('id', '');
        }
    }

    return {
        show: showLoadingLayer,
        hide: hideLoadingLayer
    };
});